import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UpdateAndDeleteProduct, UpdateAndDeleteRfq } from '../../../../services/ProductService/AllProductList/AllProductServices';

const TableActionPopUp = ({ ProductId, onSuccess, RfqId, onRfqSuccess, onRfqSingleView, onRfqEditSingleView, onProductEditSingleView }) => {
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [showSuccessRfqPopup, setShowSuccessRfqPopup] = useState(false);
    const navigate = useNavigate();

    const handleDeleteProduct = async (ProductId) => {
        if (ProductId) {
            try {
                const response = await UpdateAndDeleteProduct('DELETE', ProductId, {});
                if (response) {
                    setShowConfirmPopup(false);
                    setShowSuccessPopup(true);
                    setTimeout(() => {
                        setShowSuccessPopup(false);
                        onSuccess(); // Call after timeout
                    }, 2000);
                }
            } catch (error) {
                console.error('Failed to delete product:', error);
            }
        }
    };

    const handleDeleteRfq = async (RfqId) => {
        if (RfqId) {    
            try {
                const response = await UpdateAndDeleteRfq('DELETE', RfqId, {});
                if (response) {
                    setShowConfirmPopup(false);
                    setShowSuccessRfqPopup(true);
                    setTimeout(() => {
                        setShowSuccessPopup(false);
                        onRfqSuccess(); // Call after timeout
                    }, 2000);
                }
            } catch (error) {
                console.error('Failed to delete RFQ:', error);
            }
        }
    };

    const handleShowSingleProductPage = () => {
        if (ProductId) {
            navigate(`/admin-dashboard/product-module/view-product/${ProductId}`);
        }
    };

    const handleShowSingleRfqPage = () => {
        onRfqSingleView(RfqId)
    };

    const handleShowSingleEditRfqPage = () => {
        onRfqEditSingleView(RfqId)
    };

    const handleShowSingleEditProductPage = () => {
        // onProductEditSingleView(ProductId)
        const id = ProductId
        if (id) {
            navigate(`/admin-dashboard/product-module/view-product/${id}?mode=edit`);
        }
    };

    return (
        <>
            {/* Action Popup */}
            <div className="bg-white shadow-md p-4 border rounded-lg w-fit">
                {RfqId ? (<div
                    className="cursor-pointer px-2 py-1 hover:bg-gray-200"
                    onClick={handleShowSingleEditRfqPage}
                >
                    Edit
                </div>) : (<div
                    className="cursor-pointer px-2 py-1 hover:bg-gray-200"
                    onClick={handleShowSingleEditProductPage}
                >
                    Edit
                </div>)}
                {RfqId ? (<div
                    className="cursor-pointer px-2 py-1 hover:bg-gray-200"
                    onClick={handleShowSingleRfqPage}
                >
                    View
                </div>) : (<div
                    className="cursor-pointer px-2 py-1 hover:bg-gray-200"
                    onClick={handleShowSingleProductPage}
                >
                    View
                </div>)}
                <div
                    className="cursor-pointer px-2 py-1 text-red-500 hover:bg-red-200"
                    onClick={() => setShowConfirmPopup(true)}
                >
                    Delete
                </div>
            </div>

            {/* Confirmation Popup */}
            {showConfirmPopup && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg">
                        <div className="text-center">
                            <div className="text-red-500 text-4xl mb-2">❓</div>
                            <p className="text-lg">Do you want to delete this {RfqId ? 'Enquiry' : 'Product'}?</p>
                        </div>
                        <div className="flex justify-center gap-4 mt-4">
                            <button
                                className="px-4 py-2 border border-red-500 text-red-500 rounded font-bold"
                                onClick={() => setShowConfirmPopup(false)}
                            >
                                Cancel
                            </button>
                            {RfqId ? (<button
                                className="px-4 py-2 bg-red-600 text-white rounded font-bold"
                                onClick={()=>handleDeleteRfq(RfqId)}
                            >
                                Delete
                            </button>) : (<button
                                className="px-4 py-2 bg-red-600 text-white rounded font-bold"
                                onClick={()=>handleDeleteProduct(ProductId)}
                            >
                                Delete
                            </button>)}
                        </div>
                    </div>
                </div>
            )}

            {/* Success Popup */}
            {showSuccessPopup && (
                <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-4 py-2 rounded-md shadow-md">
                    Product deleted successfully!
                </div>
            )}
            
            {showSuccessRfqPopup && (
                <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-4 py-2 rounded-md shadow-md">
                    Enquiry deleted successfully!
                </div>
            )}
        </>
    );
};

export default TableActionPopUp;